import Base from '../Base';

export default class School extends Base {
    static url = '/api/school';
}
